export default __webpack_public_path__ + "illustrations.0169b27c.svg";